// Copyright (c) 2017 Deere & Company

const pipCodeRequestSortOptions = [
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'DEALER',
        path: ['dealer', 'account']
    },
    {
        displayName: 'PIP_NUMBER',
        path: ['pipNumber']
    },
    {
        displayName: 'PIP_CODE',
        path: ['pipCodeType', 'value']
    },
    {
        displayName: 'CREATED',
        path: ['createDate']
    }
];

export default pipCodeRequestSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/pip-code-request-sort-options.js